import { ClientConfig } from "@/models/clientConfig";
import { defineStore } from "pinia";
import { ref } from "vue";
import { mainServices } from "@/services/mainServices";

export const useRequirementsStore = defineStore("requirements", () => {
  const requirementsData = ref({
    medicationRequirements: null,
    diagnosisRequirements: null,
    payerQuestions: null,
    stepTherapyRequirements: null,
    insurancePlanTypes: null,
  });
  const clientConfig = ref(null);
  // Kept out of the shared clientConfig slot so a company-scoped refresh can't wipe them. null = not loaded.
  const supportTicketDashboardEnabled = ref(null);
  const billingEnabled = ref(null);

  async function refreshClientConfig(clientCompanyId) {
    clientConfig.value = null;
    const response = await mainServices.getClientConfig(clientCompanyId);
    clientConfig.value = new ClientConfig(response, clientCompanyId);
  }

  async function refreshCurrentUserClientConfig() {
    clientConfig.value = null;
    const response = await mainServices.getCurrentUserClientConfig();
    clientConfig.value = new ClientConfig(response, response.clientCompanyId);
    supportTicketDashboardEnabled.value = response.supportTicketDashboardEnabled ?? false;
    billingEnabled.value = response.billingEnabled ?? false;
  }

  async function ensureSupportTicketDashboardFlag() {
    if (typeof supportTicketDashboardEnabled.value === "boolean") {
      return supportTicketDashboardEnabled.value;
    }
    const response = await mainServices.getCurrentUserClientConfig();
    supportTicketDashboardEnabled.value = response.supportTicketDashboardEnabled ?? false;
    return supportTicketDashboardEnabled.value;
  }

  return {
    requirementsData,
    clientConfig,
    supportTicketDashboardEnabled,
    billingEnabled,
    refreshClientConfig,
    refreshCurrentUserClientConfig,
    ensureSupportTicketDashboardFlag,
  };
});
